export default __webpack_public_path__ + "static/media/1990.d60677ee.png";